import { useEffect, useState } from 'react';

const useLocalStorage = (key, initialValue) => {
  const [value, setValue] = useState(() => {
    try {
      const localStorageData = JSON.parse(localStorage.getItem(key));
      if (localStorageData) {
        return localStorageData;
      }

      return initialValue;
    } catch (error) {
      initialValue;
    }
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [value]);

  return [value, setValue];
};

export default useLocalStorage;
